import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GTBuySpreadsheetGuide from "../pages/article/gtbuy-spreadsheet-guide/page";
import GTBuyShoppingTips2026 from "../pages/article/gtbuy-shopping-tips-2026/page";
import BestGTBuyCategories from "../pages/article/best-gtbuy-categories-guide/page";
import GTBuyVsTraditional from "../pages/article/gtbuy-vs-traditional-shopping/page";
import HowToFindDeals from "../pages/article/how-to-find-deals-gtbuy/page";
import GTBuyBeginners from "../pages/article/gtbuy-sheet-beginners/page";
import GTBuyFashionTrends from "../pages/article/gtbuy-fashion-trends-2026/page";
import SmartShoppingGTBuy from "../pages/article/smart-shopping-gtbuy/page";
import GTBuyProductComparison from "../pages/article/gtbuy-product-comparison/page";
import GTBuySheetFAQ from "../pages/article/gtbuy-sheet-faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/gtbuy-spreadsheet-guide",
    element: <GTBuySpreadsheetGuide />,
  },
  {
    path: "/article/gtbuy-shopping-tips-2026",
    element: <GTBuyShoppingTips2026 />,
  },
  {
    path: "/article/best-gtbuy-categories-guide",
    element: <BestGTBuyCategories />,
  },
  {
    path: "/article/gtbuy-vs-traditional-shopping",
    element: <GTBuyVsTraditional />,
  },
  {
    path: "/article/how-to-find-deals-gtbuy",
    element: <HowToFindDeals />,
  },
  {
    path: "/article/gtbuy-sheet-beginners",
    element: <GTBuyBeginners />,
  },
  {
    path: "/article/gtbuy-fashion-trends-2026",
    element: <GTBuyFashionTrends />,
  },
  {
    path: "/article/smart-shopping-gtbuy",
    element: <SmartShoppingGTBuy />,
  },
  {
    path: "/article/gtbuy-product-comparison",
    element: <GTBuyProductComparison />,
  },
  {
    path: "/article/gtbuy-sheet-faq",
    element: <GTBuySheetFAQ />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;